import * as MobX from "mobx";
import { ModelBase } from "@shoothill/core";
import { computed } from "mobx";
export class HireTrackerItemModel extends ModelBase<HireTrackerItemModel, HireTrackerReportItemDTO> {
    @MobX.observable
    public id: string = "";

    @MobX.observable
    public itemId: string = "";

    @MobX.observable
    public quantity: number = 0;

    @MobX.observable
    public unitPrice: number = 0;

    @MobX.observable
    public description: string = "";

    @MobX.observable
    public supplierName: string = "";

    @MobX.observable
    public formattedPONumber: string = "";

    @MobX.observable
    public hireStartDate: Date | null = null;

    @MobX.observable
    public hireEndDate: Date | null = null;

    @MobX.observable
    public total: number = 0;

    @MobX.observable
    public duration: number = 0;

    @MobX.observable
    public hireStatusName: string = "";

    @MobX.observable
    public hireStatusId: string | null = null;

    @MobX.observable
    public offHireDate: Date | null = null;

    @MobX.observable
    public hireNote: string | null = null;

    fromDto(model: HireTrackerReportItemDTO): void {
        for (let key in model) {
            if (model.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(model[key]);
                } else {
                    this[key] = model[key];
                }
            }
        }
    }

    toDto(): HireTrackerReportItemDTO {
        return {
            id: this.id,
            itemId: this.itemId,
            quantity: this.quantity,
            unitPrice: this.unitPrice,
            description: this.description,
            supplierName: this.supplierName,
            formattedPONumber: this.formattedPONumber,
            hireStartDate: this.hireStartDate,
            hireEndDate: this.hireEndDate,
            total: this.total,
            duration: this.duration,
            hireStatusName: this.hireStatusName,
            hireStatusId: this.hireStatusId,
            offHireDate: this.offHireDate,
            hireNote: this.hireNote,
        };
    }

    toUpsertDto(): UpsertHireTrackerReportItemDTO {
        return {
            id: this.id,
            requisitionRequestItemId: this.itemId,
            hireNote: this.hireNote,
            offHireDate: this.offHireDate,
            hireStatusId: this.hireStatusId,
            userId: null,
        };
    }

    @computed
    public get validateHireStatusId(): string {
        if (this.hireStatusId === null) {
            return "Please select a status.";
        }

        return "";
    }

    @computed
    public get validateOffHireDate(): string {
        if (this.offHireDate === null) {
            return "Please select a date.";
        }

        return "";
    }
}

export type HireTrackerReportItemDTO = {
    id: string;
    itemId: string;
    quantity: number;
    unitPrice: number;
    description: string;
    supplierName: string;
    formattedPONumber: string;
    hireStartDate: Date | null;
    hireEndDate: Date | null;
    total: number;
    duration: number;
    hireStatusName: string;
    hireStatusId: string | null;
    offHireDate: Date | null;
    hireNote: string | null;
};

export type UpsertHireTrackerReportItemDTO = {
    id: string;
    requisitionRequestItemId: string;
    hireNote: string | null;
    offHireDate: Date | null;
    hireStatusId: string | null;
    userId: string | null;
};
